<div class="accounts">
  @if (accounts$ | async; as accounts) {
    @for (account of accounts; track account) {
      <div class="account">
        <div class="account__icon">
          <fa-icon
            [icon]="
              $safeNavigationMigration(externalServiceMap[account.id]?.icon)
            "
            [size]="'5x'"
            [style.color]="externalServiceMap[account.id]?.color"
          ></fa-icon>
        </div>
        <div class="account__name">{{ account.name }}</div>
        @if (account.time_expire) {
          <div class="account__expires_at">
            Expires: {{ account.time_expire * 1000 | date: "medium" }}
          </div>
        }
        <div class="account__actions">
          @if (!account.is_active) {
            <sui-button
              variant="primary"
              [leadingIcon]="['fas', 'check']"
              (click)="activate(account.id)"
              >Activate</sui-button
            >
          }
          @if (account.is_active) {
            <sui-button
              variant="danger"
              [leadingIcon]="['fas', 'unlink']"
              (click)="unlink(account.id)"
              >Unlink</sui-button
            >
          }
        </div>
      </div>
    }
  }
</div>
